import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import ContractEventsTable from './ContractEventsTable';

const ContractEventsDetail = ({ contractEvents }) => {
  return (
    <Box mt={3}>
      <ContractEventsTable contractEvents={contractEvents} />
    </Box>
  );
};

ContractEventsDetail.propTypes = {
  contractEvents: PropTypes.array
};

export default ContractEventsDetail;
